<template>
  <div style="margin-top:70px;" class="dashboard-page">
    
    <Summary />
    <div class="text-center mt-4">
      ¿Gestionar otro día diferente? Haga click 
      <router-link 
        to="/app/excursiones/excursiones" 
        class="text-uppercase font-weight-bold"
        @click.native="navigateEmptyDay"
      >
          aquí
      </router-link>
    </div>

    <div class="my-4">
      <b-container>
        <b-alert show variant="warning" class="font-weight-bold text-center">
          <i class="fa fa-exclamation-triangle fa-fw fa-2x mr-2"></i>
          <span>
            Existen {{unconfiguredActivities}} planificaciones (schedulers) de actividades actualmente activas en Trekksoft que no están configuradas en la aplicación
          </span>
          <div class="mt-3">
            <b-button variant="light" class="bg-white text-black-50" @click="navigateConfigureActivities()">
              <i class="fa fa-wrench fa-fw mr-1"></i>
              <span>
                Configurar
              </span>
            </b-button>
          </div>
        </b-alert>
      </b-container>
    </div>

    <Details />
  </div>
</template>

<script>
/* eslint-disable */
import Summary from "../../components/Dashboard/Summary";
import Details from "../../components/Dashboard/Details";
import { mapGetters } from 'vuex';

export default {
  components: {
    Summary,
    Details,
  },
  async created() {
    await this.$store.dispatch("activities/get_activities")
  },
  data() {
    return {}
  },
  methods: {
    navigateEmptyDay() {
      let filtersData = {
          suprazone: null,
          date: null,
          group: 0,
      };
      
      this.$store.dispatch("filters/updateFilters", filtersData);
      this.$store.dispatch("layout/setActiveTabAndOption", {tab: 'Excursions', option: 'Activity'})
    },
    navigateConfigureActivities() {
      this.$store.dispatch("layout/setActiveTabAndOption", {tab: 'Admin', option: 'admin-activities'})
      this.$router.push('/app/admin-panel')
    }
  },
  computed: {
    ...mapGetters(["activities"]),
    unconfiguredActivities() {
      let activeActivities = this.activities.filter(
        item => item.count_active > 0
      )
      let unconfiguredActiveActivities = activeActivities.filter(
        item => item.count_unconfigured_schedulers > 0
      ).filter( item => item.source_integration == 'zerotours' )
      return unconfiguredActiveActivities.length
    }
  }
};
</script>